import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';
import { isEmpty } from 'lodash';
import BasicModal from '../BaseDialog/BaseDialog.js';
import Actions from './Actions.js';

const _BaseDialog = styled(BasicModal, {
    shouldForwardProp: prop => !['size', 'withGhostButton'].includes(prop),
}) `
  ${({ size, withGhostButton }) => {
    const isValidSize = !!size && ['small', 'medium'].includes(size);
    if (isValidSize) {
        return `width: ${size === 'small' ? 300 : 440}px`;
    }
    return `min-width: ${withGhostButton ? 400 : 320}px;`;
}};
  padding: ${({ theme }) => theme.spacing(6.5, 8, 8)};
`;
const Title = styled(MuiTypography) `
  line-height: 42px;
  text-align: center;
  overflow-wrap: anywhere;
  ${({ theme }) => `
    color: ${theme.palette.N20.main};
    margin: ${theme.spacing(4, 0)};
  `}
`;
const Description = styled(MuiTypography) `
  ${({ theme }) => `
    color: ${theme.palette.N10.main};
    line-height: 16px;
    text-align: center;
    white-space: pre-line;
  `}
`;
const MessageDialog = (_a) => {
    var { title, children, size, onClose, actions = {}, icon, 'data-testid': testId = 'dialog-content' } = _a, rest = __rest(_a, ["title", "children", "size", "onClose", "actions", "icon", 'data-testid']);
    return (jsxs(_BaseDialog, Object.assign({ onClose: onClose, size: size, withGhostButton: !!actions.ghost, "data-testid": testId }, rest, { children: [icon, jsx(Title, Object.assign({ variant: "h1" }, { children: title })), jsx(Description, Object.assign({ variant: "body1" }, { children: children })), jsx(Actions, Object.assign({ hide: isEmpty(actions) }, actions, { size: size }))] })));
};

export { MessageDialog as default };
//# sourceMappingURL=MessageDialog.js.map
